"use client";

import { useState } from "react";
import { Menu, X } from "lucide-react";
import Link from "next/link";
import AuthAction from "@/components/site/AuthAction";


export default function HeaderNav({ logoUrl, navLinks }) {
    const [isOpen, setIsOpen] = useState(false);



    return (
        <header className={"px-4 md:px-8 py-4 container relative"}>
            <nav className={"flex justify-between items-center"}>
                <Link href={"/"}>
                    <img src={logoUrl} alt={"logo"} width={75} height={50} />
                </Link>

                {/* Desktop nav */}
                <div className={"hidden lg:flex gap-x-8 items-center pr-10 pl-12"}>
                    {navLinks.map((link) => (
                        <Link key={link.label} href={link.link}>
                            <button className={"font-medium text-[#404040]"}>
                                {link.label}
                            </button>
                        </Link>

                    ))}
                </div>

                <div className={"flex items-center gap-x-3"}>
                    <AuthAction
                        trigger={(
                            <button className={"hidden md:flex bg-primary text-white font-semibold px-4 py-2 md:px-6 md:py-2.5 rounded-md text-sm md:text-base hover:shadow-lg hover:shadow-[#F0A202]/20 transition-all hover:-translate-y-0.5"}>
                                Nous rejoindre
                            </button>
                        )}
                        placeholder={(
                            <Link href={"/dashboard"}>
                                <button className={"hidden md:flex bg-primary text-white font-semibold px-4 py-2 md:px-6 md:py-2.5 rounded-md text-sm md:text-base hover:shadow-lg hover:shadow-[#F0A202]/20 transition-all hover:-translate-y-0.5"}>
                                    Mon tableau de bord
                                </button>
                            </Link>
                        )}
                    />

                    {/* Hamburger */}
                    <button
                        className={"lg:hidden p-2"}
                        onClick={() => setIsOpen(!isOpen)}
                        aria-label={"Toggle menu"}
                    >
                        {isOpen ? <X size={24} color={"#404040"} /> : <Menu size={24} color={"#404040"} />}
                    </button>
                </div>
            </nav>

            {/* Mobile drawer */}
            {isOpen && (
                <div className={"lg:hidden absolute top-full left-0 right-0 bg-white shadow-lg z-50 border-t border-[#E5E5E5]"}>
                    <div className={"flex flex-col px-6 py-4 gap-y-1"}>
                        {navLinks.map((link) => (
                            <Link href={link.link} key={link.label}>
                                <button
                                    className={"font-medium text-[#404040] text-left py-3 border-b border-[#F5F5F5] last:border-0"}
                                    onClick={() => setIsOpen(false)}
                                >
                                    {link.label}
                                </button>
                            </Link>
                        ))}
                        <AuthAction
                            trigger={(
                                <button className={"bg-primary text-white font-semibold px-4 py-2 md:px-6 md:py-2.5 rounded-md text-sm md:text-base hover:shadow-lg hover:shadow-[#F0A202]/20 transition-all hover:-translate-y-0.5"}>
                                    Nous rejoindre
                                </button>
                            )}
                            placeholder={(
                                <Link href={"/dashboard"}>
                                    <button className={"bg-primary text-white font-semibold px-4 py-2 md:px-6 md:py-2.5 rounded-md text-sm md:text-base hover:shadow-lg hover:shadow-[#F0A202]/20 transition-all hover:-translate-y-0.5"}>
                                        Mon tableau de bord
                                    </button>
                                </Link>
                            )}
                        />
                    </div>
                </div>
            )}
        </header>
    );
}